import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';

import {
  setModal,
  showModal,
  setSolution
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].type,
    open: state.notebook.protocolSection.scene.apparatus.thermocyclers[ownProps.id-1].open
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setModal: (data) => {
      dispatch(setModal(data))
    },
    showModal: (data) => {
      dispatch(showModal(data))
    },
    setSolution: (data) => {
      dispatch(setSolution(data))
    }
  };
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
